module.exports = __webpack_public_path__ + "img/caisse-epargne.c86d86fa.png";